// extracted by mini-css-extract-plugin
export default {"confirm":"ConfirmModel_confirm__ODFwQ"};